/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

import {ApiService} from '../api/api.service';

@Component({
  selector: 'gp-entity-avatar',
  template: `
    <span class="circle avatar {{classes}} avatar-text"
          [ngClass]="{'w-96': size == 'lg', 'w-32': size == 'sm', 'w-48': size == 'md', green: !bgColor}"
          [style.color]="textColor"
          [style.background-color]="bgColor">
      <img *ngIf="pictureUrl" [attr.src]="pictureUrl" (error)="chooseAnotherPicture(pictureUrl)">
      <span *ngIf="!pictureUrl" [style.font-size]="size === 'md' ? '1.33rem' : null">{{ value | abbreviation }}</span>
    </span>
  `,
  styleUrls: ['./avatar.component.scss']
})
export class EntityAvatarComponent implements OnChanges {

  @Input()
  public value: string;

  @Input()
  public size: string = 'sm';

  @Input()
  public textColor: string = 'white';

  @Input()
  public bgColor: string = '#a88add';

  @Input()
  public type: string;

  @Input()
  public classes: string;

  @Input()
  public links: any[];

  public pictureUrl: string;

  private pictureUrls: Set<string> = new Set();

  constructor(public api: ApiService) {
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.links && this.links && this.links.length) {
      this.pictureUrls = new Set<string>(
        this.links.filter(link => link.rel === 'cliRegFlag')
          .map((link => `${this.api.apiHost}${link.href}`))
      );
      this.pictureUrl = this.pictureUrls.values().next().value;
    }
  }

  public chooseAnotherPicture(errorUrl: string) {
    this.pictureUrls.delete(errorUrl);
    this.pictureUrl = this.pictureUrls.values().next().value || null;
  }
}
